<template>
  <div v-if="frame" class="image-tag" v-bind:style=[outerStyleObj] @click="onClick">
    <div class="image-tag__anim" :style="animClass">
     <img v-if="imageSrc" :src="imageSrc"  v-bind:style=[innerStyleObj] class="image-tag__image" />
    </div>
  </div>
</template>
<script>

import { analytics } from './mixins/analytics/'
import { base } from './mixins/multilang'

export default {
  name: "imageTag",
  mixins: [analytics, base],
  props: ["meta", "frame", "isLastFrame", "dimensions"],
  created() {
    this.$nextTick(() => {
    });
    console.log("imageTag created", this.meta);
    this.initTag();
  },
  watch: {
    isLastFrame(isLast) {
      console.log(
        "imageTag isLastFrame %s. current frame %v",
        isLast,
        this.frame
      );
      if (isLast && this.onLastFrame.action !== "none") {
        this.$emit("videoaction", this.onLastFrame);
      }
    }
    /*
    'frame': 'onFrame',
    'dimensions': 'onDimensionChange'
    */
  },
  data() {
    return {
      // inital width and height from first frame
      iw: null,
      ih: null
    }
  },
  computed: {
    imageSize: function() {
      if (!this.frame) {
        return {}
      }
      return {
        w: this.frame.pw * this.dimensions.w,
        h: this.frame.ph * this.dimensions.h
      }
    },
    imageSrc: function() {
      console.log("imageTag imageSrc", this.selectedLanguage)
      let imageSrc = null
      if (typeof this.meta.imageSrc === 'string') {
        imageSrc = this.meta.imageSrc 
      } else if (this.meta.imageSrc) {
        imageSrc = this.getTextFromMultiLang(this.meta.imageSrc, this.selectedLanguage || this.meta.imageSrc.lang, this.version)
      }
      return imageSrc && imageSrc !== '' ? imageSrc : null
    },
    outerStyleObj: function() {
      // do not interpolate over dimensions
      // bad for performance. use case is take size from first waypoint
      console.log("outerStyleObj")
      let {w, h} = this.imageSize
      var so = {
        width: w + "px",
        height: h + "px", 
        "margin-top": -h / 2 + "px",
        "margin-left": -w / 2 + "px",
        "border-radius": this.borderRadius + "px"    
      };
      // omit the property completely if set to 0
      if (this.boxShadow > 0) {
        so['box-shadow'] = `0px 0px ${this.boxShadow}px 0px rgba(0,0,0,0.25)`
      }
      return so;
    },
    animClass: function() {
      if (this.animation) {
        var a = this.animation
        let av = ''

        if (a.value) {
          av = `${a.animation} ${a.value || 2000}ms ${a.mode || ''}`
        } else {
          av = `${a.animation} ${a.duration || 2}s infinite`
        }

        return {
          animation: av
        }
      }
      return ''
    },
    innerStyleObj: function() {
      var so = {
        "border-radius": this.borderRadius + "px"    
      };
      // omit the property completely if set to 0
      if (this.boxShadow > 0) {
        so['box-shadow'] = `0px 0px ${this.boxShadow}px 0px rgba(0,0,0,0.25)`
      }

      return so;
    }
  },
  methods: {
    initTag() {
      console.log("imageTag.inited");
      var meta = this.meta
      this.onLastFrame = meta.onLastFrame || {};
      this.behaviour = meta.behaviour || {};
      this.animation = this.meta.animation;
      this.borderRadius = meta.borderRadius || 0
      this.boxShadow = meta.boxShadow || 0
    },
    // this is called on every frame, prevent anything expensive here
    // used to calculate the inital width and height, abort early if already set for better performance
    onFrame(newFrame, oldVal) {
      if (newFrame) {
        // frame has a percent witdh of the tag, dimensions hold the dimensions of the video
        this.iw = newFrame.pw * this.dimensions.w;
        this.ih = newFrame.ph * this.dimensions.h;
      }
    },
    onClick() {
      console.log("imageTag clicked", this.meta);
      this.$emit("action", this.meta.behaviour);
       this.trackTag("Image")
    },

    // triggered from parent, will increase version and 
    forceUpdate(meta) {
      console.log("image tag override forceUpdate", this.version)
    }
  }
};
</script>
